import { render, staticRenderFns } from "./blackIdNumber.vue?vue&type=template&id=8b9b6cb0&"
import script from "./blackIdNumber.vue?vue&type=script&lang=js&"
export * from "./blackIdNumber.vue?vue&type=script&lang=js&"
import style0 from "./blackIdNumber.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports